{
  "pageTitle": "Centrum importu nośników",
  "pageSubtitle": "Importuj lub aktualizuj nośniki hurtowo z pliku XLSX lub CSV",
  "stepper": {
    "upload": "Plik",
    "supplierDedup": "Dostawcy",
    "mapping": "Mapowanie",
    "validation": "Walidacja",
    "progress": "Import",
    "result": "Wyniki"
  },
  "upload": {
    "dropZoneTitle": "Przeciągnij plik lub kliknij, aby wybrać",
    "dropZoneSubtitle": "Obsługiwane formaty: .xlsx, .xls, .xlsm, .csv, .zip lub zdjęcia .jpg/.png (maks. 10 MB / 500 MB dla .zip lub zdjęć, maks. 500 zdjęć naraz)",
    "selectFile": "Wybierz plik",
    "filePreviewRows": "{{sizeKb}} KB, ok. {{rows}} wierszy danych",
    "filePreviewSize": "{{sizeKb}} KB",
    "validTemplateStatus": "Poprawna templatka XLSX",
    "removeFile": "Usuń plik",
    "noFile": "Nie masz pliku?",
    "downloadTemplateOoh": "Szablon OOH",
    "downloadTemplateDooh": "Szablon DOOH",
    "nextButton": "Walidacja",
    "uploading": "Przesyłanie...",
    "errorSizeExceeded": "Plik jest za duży (maks. 10 MB)",
    "errorSizeExceededZip": "ZIP jest za duży (maks. 500 MB)",
    "errorNonStandard": "Plik nie odpowiada standardowemu szablonowi. Pobierz szablon i uzupełnij dane.",
    "errorInvalidFileType": "Nieobsługiwany format pliku. Dozwolone formaty: .xlsx, .xls, .xlsm, .csv, .zip",
    "errorGeneric": "Wystąpił błąd podczas wgrywania pliku",
    "errorTemplateDownload": "Nie udało się pobrać szablonu XLSX. Spróbuj ponownie.",
    "errorMixedFileTypes": "Wybierz same zdjęcia JPG/PNG albo jeden plik ZIP/XLSX",
    "errorTooManyPhotos": "Zbyt wiele zdjęć naraz (maks. {{max}})",
    "photosSelectedLabel": "{{count}} zdjęć wybranych",
    "uploadPhotosButton": "Prześlij zdjęcia",
    "supplierSelectPlaceholder": "Wybierz dostawcę",
    "supplierSearchPlaceholder": "Szukaj dostawcy…",
    "supplierNoResults": "Brak wyników",
    "supplierLoadError": "Nie udało się załadować listy dostawców"
  },
  "jobNotFound": {
    "title": "Nie znaleziono importu",
    "description": "Ten import nie istnieje albo adres strony jest nieprawidłowy. Zacznij import od początku.",
    "action": "Wróć do wgrywania"
  },
  "validation": {
    "errorChip": "{{count}} błąd",
    "errorsChip": "{{count}} błędy",
    "warningChip": "{{count}} ostrzeżenie",
    "warningsChip": "{{count}} ostrzeżenia",
    "autofixBanner": "System automatycznie poprawił <strong>{{count}} wiersze</strong> przed walidacją",
    "autofixCount": "{{count}} auto-poprawek",
    "autofixExpandAll": "Rozwiń wszystkie",
    "autofixCollapseAll": "Zwiń wszystkie",
    "summaryValid": "Poprawne",
    "summaryErrors": "Błędy",
    "summaryAutofixes": "Auto-poprawki",
    "summarySkipped": "Do pominięcia",
    "tableHeaderRow": "Wiersz",
    "tableHeaderUnit": "Nośnik",
    "tableHeaderField": "Pole",
    "tableHeaderMessage": "Komunikat",
    "tableHeaderType": "Rodzaj",
    "tableHeaderOriginal": "Wartość oryginalna",
    "tableHeaderFixed": "Wartość poprawiona",
    "tableHeaderFixType": "Rodzaj poprawki",
    "severityError": "Błąd",
    "severityWarning": "Ostrzeżenie",
    "warningText": "Wiersze z błędami nie zostaną zaimportowane. Popraw plik XLSX i zaimportuj ponownie, lub wybierz import z pominięciem błędów.",
    "allRowsHaveErrors": "Wszystkie wiersze zawierają błędy",
    "downloadErrorReport": "Pobierz raport błędów",
    "backToUpload": "Wróć do wgrywania",
    "importButton": "Importuj",
    "loading": "Walidacja...",
    "fetchError": "Nie udało się wykonać walidacji pliku. Spróbuj ponownie.",
    "retryButton": "Spróbuj ponownie",
    "expandRow": "Podgląd",
    "collapseRow": "Ukryj podgląd",
    "empty": "puste",
    "autofixHeading": "System automatycznie poprawił {{count}} wiersze przed walidacją",
    "autofixEmpty": "Brak automatycznych poprawek",
    "issuesExpandAll": "Rozwiń wszystkie",
    "issuesCollapseAll": "Zwiń wszystkie",
    "tableHeaderNosnik": "Nośnik",
    "tableHeaderKind": "Rodzaj poprawki",
    "importButtonSkip": "Importuj (pomijając błędy)",
    "rowDetailLabel": "Podgląd danych — wiersz {{row}}",
    "hideEmptyColumns": "Ukryj puste kolumny",
    "errors": {
      "unknown_tag_code": "Nieznany tag: \"{{value}}\"",
      "field_required": "Pole {{field}} jest wymagane",
      "grw_id_or_supplier_number_required": "Wymagany numer wewnętrzny lub numer dostawcy",
      "field_too_long": "Pole {{field}} nie może przekraczać {{max}} znaków",
      "unknown_field_value": "Nieznana wartość pola {{field}}: \"{{value}}\"",
      "field_out_of_range": "Pole {{field}} musi być w zakresie {{min}}–{{max}}",
      "decimal_comma_autofix": "Przecinek dziesiętny zastąpiony kropką",
      "multiformat_too_long": "Multiformat nie może przekraczać {{max}} znaków",
      "unknown_media_type": "Nieznany lub brakujący typ nośnika: \"{{value}}\"",
      "legacy_column_ignored": "Kolumna \"{{column}}\" została usunięta z szablonu i będzie ignorowana",
      "row_internal_error": "Nie udało się przetworzyć wiersza z powodu błędu wewnętrznego",
      "multiformat_sync_failed": "Nie udało się zsynchronizować grupy wielkoformatowej \"{{code}}\"",
      "pattern_no_match": "Wartość \"{{value}}\" w kolumnie \"{{field}}\" nie pasuje do wzoru \"{{pattern}}\"",
      "photo_renditions_failed": "Zdjęcie zapisane, ale nie udało się przygotować miniatur"
    }
  },
  "progress": {
    "heading": "Import w toku...",
    "photoBundleProgress": "Przetwarzam zdjęcia…",
    "processed": "Przetworzono",
    "photoBundleProcessed": "Przesłano",
    "of": "z",
    "rows": "wierszy",
    "photos": "zdjęć",
    "progressLabel": "Postęp",
    "imported": "Zaimportowane",
    "updated": "Zaktualizowane",
    "errors": "Błędy (dotychczas)",
    "photoUploaded": "Przesłane",
    "photoNotMatchedOrErrors": "Bez dopasowania / błędy"
  },
  "mapping": {
    "stepperLabel": "Mapowanie",
    "loading": "Wczytywanie kolumn...",
    "errorMissingRequired": "Brakuje wymaganego pola w mapowaniu. Uzupełnij brakujące pola.",
    "nonStandardBanner": "Nie rozpoznano standardowego formatu pliku. Przypisz kolumny ręcznie.",
    "columnHeaderSource": "Kolumna w pliku",
    "columnHeaderTarget": "Pole w systemie",
    "skipColumnOption": "Pomiń tę kolumnę",
    "fieldSearchPlaceholder": "Szukaj pola...",
    "fieldNoResults": "Brak wyników",
    "groupGeneral": "Pola ogólne",
    "groupPhysical": "Wymiary fizyczne",
    "groupMuralFlags": "Mural - warianty",
    "groupDigital": "Digital",
    "groupInternalCost": "Koszty wewnętrzne",
    "groupClientPrice": "Ceny klienckie",
    "supplierLabel": "Dostawca",
    "supplierSelectPlaceholder": "Wybierz dostawcę",
    "supplierSearchPlaceholder": "Szukaj dostawcy…",
    "supplierNoResults": "Brak wyników",
    "nextButton": "Dalej",
    "unmappedRequiredHeading": "Wymagane pola bez przypisania",
    "unmappedRequiredHint": "Poniższe wymagane pola nie zostały przypisane do żadnej kolumny. Uzupełnij mapowanie.",
    "missingRequiredHeading": "Brakujące pola w pliku dostawcy",
    "missingRequiredHint": "Plik dostawcy nie zawiera kolumn dla poniższych wymaganych pól. Skontaktuj się z dostawcą.",
    "fetchError": "Nie udało się załadować mapowania kolumn.",
    "retryButton": "Spróbuj ponownie",
    "unknownColumn": "(nieznana kolumna)",
    "typeOverrideLabel": "Typ nośnika dla całego pliku",
    "typeOverridePlaceholder": "(różne / per wiersz)",
    "typeOverrideAutoNote": "auto: nadpisanie na poziomie pliku",
    "typeOverrideFilteredHint": "Pokazano kolumny dla typu: {{type}}",
    "editPatternAriaLabel": "Edytuj wzór dopasowania",
    "fanOutNoteLabel": "patrz niżej",
    "unmatchedSampleWarningLabel": "Wzór nie pasuje do jednej z przykładowych wartości",
    "fieldInfoAriaLabel": "Informacje o polu",
    "patternDialogTitle": "Edytuj wzór dopasowania",
    "patternColumnLabelPrefix": "Kolumna:",
    "patternSampleValueTemplate": "Przykład: {value}",
    "patternFieldLabel": "Wzór",
    "patternAutoDetectedNote": "(wykryto automatycznie)",
    "patternPlaceholder": "np. {1}, {2} / {3}",
    "patternUnderstandingLabel": "Jak to działa?",
    "patternUnderstandingInfoLabel": "Jak to działa?",
    "patternUnderstandingInfoText": "Wpisz {1}, {2} itd. w miejscach wartości, które mają trafić do osobnych pól. Pozostały tekst musi dokładnie odpowiadać przykładowej wartości.",
    "patternNoBlanksHint": "Ten wzór nie zawiera symboli zastępczych — kolumna zostanie zmapowana bezpośrednio.",
    "patternMatchedTemplate": "Pasuje do {matched} z {total} przykładowych wartości",
    "patternNoMatchText": "Wzór nie pasuje do przykładowej wartości",
    "patternShowMismatchesLabel": "Pokaż niedopasowane",
    "patternHideMismatchesLabel": "Ukryj niedopasowane",
    "patternDoneButtonLabel": "Gotowe",
    "recognizedLayoutText": "Rozpoznano układ kolumn z poprzedniego importu",
    "recognizedLayoutInfoLabel": "Jak działa rozpoznawanie układu?",
    "recognizedLayoutInfoText": "Kolumny pliku porównywane są z podpisem (liczbą i nazwami nagłówków) zapisanym przy poprzednim imporcie. Przy dopasowaniu automatycznie stosowana jest zapamiętana konfiguracja mapowania i transformacji.",
    "recognizedLayoutClearLabel": "Wyczyść konfigurację",
    "valueMapDialogTitle": "Edytuj mapę wartości",
    "valueMapFromColumnLabel": "Wartość z pliku",
    "valueMapToColumnLabel": "Wartość w systemie",
    "valueMapUnmappedPlaceholder": "[wybierz…]",
    "valueMapBlockedWarningTemplate": "Import jest zablokowany, dopóki wartość \"{value}\" nie zostanie zmapowana.",
    "constantDialogTitle": "Edytuj wartość stałą",
    "constantValueFieldLabel": "Wartość stała dla wszystkich wierszy",
    "constantEditAriaLabel": "Ustaw stałą wartość",
    "constantAssignedTemplate": "→ stała: {value}",
    "sheetPickerLabel": "Arkusz",
    "headerAutoNoteTemplate": "Nagłówek: wiersz {row} · pominięto puste kolumny",
    "headerAutoInfoLabel": "Jak wykrywany jest nagłówek?",
    "headerAutoInfoText": "System automatycznie wykrywa wiersz nagłówka (pierwszy niepusty wiersz) i pomija całkowicie puste kolumny, w tym puste kolumny na początku pliku. Nie trzeba wskazywać tego ręcznie.",
    "fileSummaryTemplate": "{sizeKb} KB · ~{rows} wierszy",
    "fileSummaryTemplateRowsOnly": "~{rows} wierszy",
    "previewHeading": "Podgląd zaimportowanych danych ({count})",
    "previewRegionDerivedWarning": "Region wyznaczony na podstawie współrzędnych",
    "transformModePatternLabel": "Wzór",
    "transformModeValueMapLabel": "Słownik wartości",
    "modeToggleInfoLabel": "Czym różnią się tryby?",
    "modeToggleInfoText": "Wzór — wyciąga wartość z komórki wg szablonu z symbolami {1}, {2}. Słownik wartości — mapuje konkretne wartości z pliku na konkretne wartości w systemie (np. \"B360\" → \"billboard\").",
    "constantTypeOptions": {
      "billboard": "Billboard",
      "backlight": "Backlight",
      "citylight": "Citylight",
      "słup": "Słup",
      "cityscroll": "Cityscroll",
      "konstrukcja": "Konstrukcja",
      "wielki format": "Wielki format",
      "mural": "Mural",
      "dooh": "DOOH",
      "inne": "Inne"
    },
    "transformDialogInfoLabel": "Jak działa mapowanie transformacji?",
    "transformDialogInfoText": "To okno pozwala przekształcić wartości z kolumny pliku na wartości oczekiwane przez system. Wybierz „Wzór”, aby wyodrębnić jedną lub więcej wartości z surowego tekstu kolumny za pomocą symboli {1}, {2} itd. Wybierz „Słownik wartości”, aby wprost przypisać każdą napotkaną wartość z pliku do jej odpowiednika w systemie.",
    "constantValueSearchPlaceholder": "Szukaj wartości...",
    "enumOptionsLoadingLabel": "Wczytywanie wartości...",
    "enumOptionsErrorLabel": "Nie udało się załadować listy formatów"
  },
  "result": {
    "headingSuccess": "Import zakończony",
    "headingWithErrors": "Import zakończony z błędami",
    "processed": "Przetworzono {{totalRows}} wierszy",
    "statImported": "Zaimportowane",
    "statUpdated": "Zaktualizowane",
    "statSkipped": "Pominięte",
    "statErrors": "Błędy",
    "statUploaded": "Przesłane",
    "statWarnings": "Ostrzeżenia",
    "viewImportedButton": "Pokaż zaimportowane nośniki",
    "downloadErrorReport": "Pobierz raport błędów ({{count}} wierszy)",
    "downloadErrorReportFailed": "Nie udało się pobrać raportu błędów",
    "errorReportColumnRow": "Wiersz",
    "errorReportColumnGrwId": "Numer GRW",
    "errorReportColumnField": "Pole",
    "errorReportColumnMessage": "Komunikat",
    "errorReportColumnSeverity": "Waga",
    "goToInventory": "Przejdź do katalogu nośników",
    "messages": {
      "uploadedSuccessfully": "Zaimportowano pomyślnie",
      "noMediaUnitFound": "Pominięto: nie znaleziono nośnika dla numeru dostawcy '{{supplierNumber}}'",
      "nestedZipDirectoryNotSupported": "Pominięto: zagnieżdżone katalogi ZIP nie są obsługiwane",
      "unrecognizedImageFile": "Pominięto: nierozpoznany plik obrazu ({{extension}})",
      "couldNotParseSupplierNumber": "Pominięto: nie udało się odczytać numeru dostawcy z nazwy pliku",
      "photoLimitReached": "Pominięto: osiągnięto limit zdjęć (maks. {{limit}} na nośnik)",
      "photoAlreadyPresent": "Zdjęcie już istnieje, zachowano",
      "uploadFailed": "Przesyłanie nie powiodło się, skontaktuj się ze wsparciem, jeśli problem będzie się powtarzał",
      "associationFailed": "Zdjęcie przesłane, ale nośnik może nie pojawić się na liście zaimportowanych (błąd zapisu powiązania)",
      "uploadedRenditionsFailed": "Zdjęcie zapisane, ale nie udało się przygotować miniatur",
      "photoRenditionsFailed": "Zdjęcie zapisane, ale nie udało się przygotować miniatur"
    },
    "unmatchedCallout": "{{count}} zdjęć nie dopasowano do żadnego nośnika",
    "photosBundleSuccess": "Zdjęcia zaimportowane",
    "photoBundleTableHeaderFile": "Plik",
    "photoBundleTableHeaderStatus": "Status",
    "photoBundleTableHeaderMessage": "Komunikat",
    "backToImport": "Powrót do importu"
  },
  "supplierDedup": {
    "heading": "Weryfikacja dostawców",
    "subheading": "Znaleziono nazwy dostawców podobne do istniejących. Wybierz działanie dla każdej z nich.",
    "useExistingLabel": "Użyj istniejącego",
    "similaritySuffix": "zgodności",
    "createNewLabel": "Utwórz nowego dostawcę",
    "nextButton": "Dalej",
    "submitting": "Zapisywanie...",
    "errorGeneric": "Nie udało się zapisać decyzji. Spróbuj ponownie.",
    "columnFileName": "Nazwa w pliku",
    "columnAction": "Działanie",
    "columnSuggestions": "Podobni dostawcy w systemie",
    "allDecidedHint": "Wybierz działanie dla każdego dostawcy z listy powyżej."
  }
}
